import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useRouteError } from 'react-router-dom';
import { CardWrapper } from './src/AppWrapper';
import { formatUnknownError } from './src/error-formatting';

function useIsOnNewPage() {
  const location = useLocation();
  return location.pathname !== '/';
}

export function ErrorElement() {
  const { t } = useTranslation();
  const error = useRouteError();
  const navigate = useNavigate();
  const isOnNewPage = useIsOnNewPage();
  return (
    <CardWrapper>
      <Stack spacing={2}>
        <div>
          <Typography id="technicalLoginErrorHeading" variant="h1" gutterBottom>
            {t('Technische Fout')}
          </Typography>
          <Typography color="error" gutterBottom>
            {formatUnknownError(error)}
          </Typography>
          <Typography gutterBottom>{t('technicalErrorMessage')}</Typography>
        </div>

        <div>
          <Button
            id="retryLoginButton"
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => {
              navigate(isOnNewPage ? '/overview' : '/');
            }}
          >
            {t('Opnieuw')}
          </Button>
        </div>
      </Stack>
    </CardWrapper>
  );
}
